var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('hot-dropdown',{ref:"dropdownRef",class:['hot-dropdocked', _vm.dropdownClass]},[_vm._t("button"),_vm._v(" "),_vm._t("menu")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }